import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Typography } from "../../../Typography/index.js";
import { Box } from "../../../Box/index.js";
import { Icon } from "../../../Icon/index.js";
import { useStyles } from "../Preview.styles.js";
import { useIsDesktop } from "../../../hooks/index.js";
const DownloadButton = (t0)=>{
    const $ = c(10);
    const { onClick, clickable } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[0] = t1;
    } else t1 = $[0];
    const { classes } = useStyles(t1);
    const isDesktop = useIsDesktop();
    if (clickable && !isDesktop) {
        let t2;
        if ($[1] !== classes.mobileCollapseBox || $[2] !== onClick) {
            t2 = /*#__PURE__*/ jsx("div", {
                className: classes.mobileCollapseBox,
                onClick: onClick
            });
            $[1] = classes.mobileCollapseBox;
            $[2] = onClick;
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    if (isDesktop) {
        let t2;
        if ($[4] !== classes.downloadButton || $[5] !== onClick) {
            t2 = onClick && /*#__PURE__*/ jsxs(Box, {
                className: classes.downloadButton,
                onClick: onClick,
                children: [
                    /*#__PURE__*/ jsx(Typography, {
                        variant: "subtitle2",
                        color: "original.brand.primary",
                        children: "Скачать"
                    }),
                    /*#__PURE__*/ jsx(Icon, {
                        name: "download_outline",
                        size: "16",
                        color: "original.brand.primary"
                    })
                ]
            });
            $[4] = classes.downloadButton;
            $[5] = onClick;
            $[6] = t2;
        } else t2 = $[6];
        let t3;
        if ($[7] !== classes.collapseBox || $[8] !== t2) {
            t3 = /*#__PURE__*/ jsx("div", {
                className: classes.collapseBox,
                children: t2
            });
            $[7] = classes.collapseBox;
            $[8] = t2;
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    return null;
};
export { DownloadButton };
